"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventHandlerState = void 0;
class EventHandlerState {
    constructor(id, subject, eventType, schedule, args, filter = undefined) {
        this.id = id;
        this.subject = subject;
        this.eventType = eventType;
        this.schedule = schedule;
        this.args = args;
        this.filter = filter;
        this.meta = {};
    }
}
exports.EventHandlerState = EventHandlerState;
